require('./ctxProgressbar.style.scss');

class CtxProgressbarController {
    constructor($scope, $timeout, $element, $attrs) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$element = $element;
        this.$attrs = $attrs;

        this.now = this.now || 0;

        let unwatch = this.$scope.$watch(() => this.now, () => {
            if(this.now >=  1) {
                unwatch();
            }
            this.$element.find('.progress-bar').attr('data-transitiongoal', this.now * 100).progressbar({display_text: 'center'});
        });

        this.$scope.$watch(() => this.$element.find('.progressbar-back-text').width(), (width) => {
            this.$element.find('.progressbar-front-text').width(width);
        })
    }
}

const ctxProgressbarComponent = {
    controller: CtxProgressbarController,
    controllerAs: 'ctxProgressbarCtrl',
    template: require('./ctxProgressbar.template.html'),
    bindings: {
        now: '='
    }
};

CtxProgressbarController.$inject = ['$scope', '$timeout', '$element', '$attrs'];

module.exports = ctxProgressbarComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxProgressbar/ctxProgressbar.component.js